/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { reduxForm } from 'redux-form';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { getLocalStorageItem } from '../../utils/localStorage';
import { AcceptTermsView } from './accept-terms-view';
import { FORM_NAME } from './constants';
import { getIsButtonEnabledSelector, getIsFormSendingSelector } from './selectors';
import { acceptTermsAction } from './actions';
import { useInjectSaga } from '../../utils/injectSaga';
import saga from './saga';
import { getFromStorage } from '../../components/sidebar/utils';
import { ModalWindow } from '../../semantic-ui/components/modal-window';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from './reducer';

const AcceptTermsWrapper = ({ isButtonEnabled, isFormSending, onAcceptTerms }) => {
	useInjectSaga({ key: 'acceptTermsPageSaga', saga });
	useInjectReducer({ key: 'termsContainerReducer', reducer });

	const history = useHistory();

	const user_data = getFromStorage('user_data');

	const [modalShow, setModalShow] = useState(false);

	useEffect(() => {
		if (user_data.email_verified_at && !user_data.accepted_terms_at) {
			setModalShow(true);
		}
	}, [user_data]);

	const handleButtonClick = () => {
		onAcceptTerms(history.push);
	};

	return (
		<ModalWindow
			isModalShown={modalShow}
			modalContent={
				<AcceptTermsView
					isButtonEnabled={isButtonEnabled}
					isFormSending={isFormSending}
					onButtonClick={handleButtonClick}
				/>
			}
			style={{ width: '595px' }}
		/>
	);
};

const AcceptTermsWithForm = reduxForm({
	form: FORM_NAME,
	enableReinitialize: true,
})(AcceptTermsWrapper);

const mapStateToProps = createStructuredSelector({
	isButtonEnabled: getIsButtonEnabledSelector(),
	isFormSending: getIsFormSendingSelector(),
});

const mapDispatchToProps = {
	onAcceptTerms: acceptTermsAction,
};

AcceptTermsWrapper.propTypes = {
	isButtonEnabled: PropTypes.bool.isRequired,
	isFormSending: PropTypes.bool.isRequired,
	onAcceptTerms: PropTypes.func.isRequired,
};

const AcceptTerms = connect(mapStateToProps, mapDispatchToProps)(AcceptTermsWithForm);

export { AcceptTerms };
